import Toggle from "react-toggle";
import React from "react";
import {Controller} from "react-hook-form";

const FormToggle = ( { validate, control, name, readOnly, options }) =>
{
    return <Controller
        control={control}
        name={name}
        rules={{ required: false, validate: validate}}
        render={({ field: { onChange, value, name, ref },
                     fieldState: { invalid, isTouched, isDirty, error },
                     formState,
                 }) => <Toggle
                name={name}
                icons={true}
                disabled={readOnly}
                onChange={onChange}
                colSpan={6}
                defaultChecked={value}
            />}
    />
}

export default FormToggle ;
